/**
 * Load Razorpay checkout.js once and reuse a shared Promise so concurrent
 * callers don't attach duplicate load listeners.
 */
let razorpayLoadPromise = null;

export async function loadRazorpayCheckout() {
  if (typeof window !== 'undefined' && window.Razorpay) return true;

  if (razorpayLoadPromise) return razorpayLoadPromise;

  razorpayLoadPromise = new Promise((resolve) => {
    const existing = document.querySelector(
      'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
    );

    const finish = (ok) => {
      if (!ok) razorpayLoadPromise = null;
      resolve(Boolean(ok));
    };

    if (existing) {
      if (window.Razorpay) {
        finish(true);
        return;
      }
      existing.addEventListener('load', () => finish(true), { once: true });
      existing.addEventListener('error', () => finish(false), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => finish(true);
    script.onerror = () => finish(false);
    document.body.appendChild(script);
  });

  return razorpayLoadPromise;
}
